import { render, staticRenderFns } from "./BillList.vue?vue&type=template&id=5d2607a5&scoped=true"
import script from "./BillList.vue?vue&type=script&lang=js"
export * from "./BillList.vue?vue&type=script&lang=js"
import style0 from "./BillList.vue?vue&type=style&index=0&id=5d2607a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2607a5",
  null
  
)

export default component.exports